module.exports = __webpack_public_path__ + "static/media/nice.7a57e5d3.jpg";